/**
 * Запоминание раскрытия «гармошек» на карточке заказа (`OrderDetailPage`).
 * По каждому `orderId` отдельно; при первом открытии заказа значения в хранилище
 * нет — UI остаётся свёрнутым.
 */

export const ORDER_DETAIL_UI_STORAGE_KEY = 'stryzh_admin.order_detail.ui'

type OrderDetailUiRow = { billing?: boolean }

type Stored = Record<string, OrderDetailUiRow>

function readAll(): Stored {
  try {
    const raw = window.localStorage.getItem(ORDER_DETAIL_UI_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as unknown
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed as Stored
  } catch {
    // private mode / квота — молча как в `utils/scope.ts`
  }
  return {}
}

/** `undefined` — ещё не задавали: показывать блок «Стоимость» свёрнутым */
export function loadOrderDetailBillingExpanded(orderId: string): boolean | undefined {
  if (!orderId) return undefined
  const v = readAll()[orderId]?.billing
  return typeof v === 'boolean' ? v : undefined
}

export function saveOrderDetailBillingExpanded(orderId: string, expanded: boolean): void {
  if (!orderId) return
  try {
    const all = readAll()
    const prev = all[orderId] ?? {}
    all[orderId] = { ...prev, billing: expanded }
    window.localStorage.setItem(ORDER_DETAIL_UI_STORAGE_KEY, JSON.stringify(all))
  } catch {
    // см. readAll
  }
}
